import { P as PubSub } from './pubsub-CoPYzvVm.js';
import './notyf-DIw0RvBj.js';

class SearchInput extends HTMLElement {
  #searchInput = this.querySelector('input[type="search"]');
  #pubsubOptions = {
    id: this.id,
    data: { value: this.#searchInput.value },
  };
  #unsubscribers = [];

  connectedCallback() {
    // Handle search input
    this.#searchInput.addEventListener('input', (event) => {
      this.#pubsubOptions.data.value = event.currentTarget.value;
      PubSub.publish('search:input', this.#pubsubOptions);
      this.#toggleClearButton();
    });

    // Handle search clear
    this.addEventListener('click', ({ target }) => {
      if (!target.closest('[data-search-clear]')) return;
      this.#clearSearchInput();
    });

    // Listen for external clear requests
    this.#unsubscribers.push(
      PubSub.subscribe('search:request-clear', ({ id }) => {
        if (id === this.id) {
          this.#clearSearchInput();
        }
      })
    );
  }

  disconnectedCallback() {
    this.#unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  /**
   * Clear the search input
   */
  #clearSearchInput() {
    this.#searchInput.value = '';
    PubSub.publish('search:clear', this.#pubsubOptions);
    this.#toggleClearButton();
    this.#searchInput.focus();
  }

  /**
   * Toggle the clear button
   */
  #toggleClearButton() {
    this.querySelector('[data-search-clear]').ariaHidden = this.#searchInput.value.length === 0;
  }
}

customElements.define('search-input', SearchInput);
